export const PAYMENT_METHODS = {
  PRIVATE: {
    MONTHLY: 'privateSingleMonthly',
    QUARTERLY: 'privateSingleQuarterly',
    SEMI_ANNUAL: 'privateSingleSemiAnnual',
  },
  BUSINESS: {
    BASIC: 'businessBasicMonthly',
    PRO: 'businessProMonthly',
  },
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
};

export const PROMOTION_TYPE = {
  RECURRING: {
    HIGHLIGHT: 'highlighted',
    RECOMMENDED: 'recommended',
    HIGHLIGHT_RECOMMENDED: 'highlightedRecommended',
  },
  ONE_TIME: {
    AD_BOOST: 'adBoost',
  },
};

export const PROMOTION_DURATION = {
  WEEKLY: 'weekly',
  TWO_WEEKS: 'twoWeeks',
  MONTHLY: 'monthly',
};

export const PROMOTION_PRICE_PER_DURATION = {
  [PROMOTION_TYPE.RECURRING.HIGHLIGHT]: {
    [PROMOTION_DURATION.WEEKLY]: '3.95 EUR',
    [PROMOTION_DURATION.TWO_WEEKS]: '6.95 EUR',
    [PROMOTION_DURATION.MONTHLY]: '11.95 EUR',
  },
  [PROMOTION_TYPE.RECURRING.RECOMMENDED]: {
    [PROMOTION_DURATION.WEEKLY]: '5.95 EUR',
    [PROMOTION_DURATION.TWO_WEEKS]: '9.95 EUR',
    [PROMOTION_DURATION.MONTHLY]: '16.95 EUR',
  },
  [PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED]: {
    [PROMOTION_DURATION.WEEKLY]: '7.95 EUR',
    [PROMOTION_DURATION.TWO_WEEKS]: '14.95 EUR',
    [PROMOTION_DURATION.MONTHLY]: '24.95 EUR',
  },
};

export const PROMOTION_TYPE_AND_DURATION_TO_VALUE = {
  [PROMOTION_TYPE.RECURRING.HIGHLIGHT]: {
    [PROMOTION_DURATION.WEEKLY]: 'highlightedWeekly',
    [PROMOTION_DURATION.TWO_WEEKS]: 'highlightedTwoWeeks',
    [PROMOTION_DURATION.MONTHLY]: 'highlightedMonthly',
  },
  [PROMOTION_TYPE.RECURRING.RECOMMENDED]: {
    [PROMOTION_DURATION.WEEKLY]: 'recommendedWeekly',
    [PROMOTION_DURATION.TWO_WEEKS]: 'recommendedTwoWeeks',
    [PROMOTION_DURATION.MONTHLY]: 'recommendedMonthly',
  },
  [PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED]: {
    [PROMOTION_DURATION.WEEKLY]: 'highlightedRecommendedWeekly',
    [PROMOTION_DURATION.TWO_WEEKS]: 'highlightedRecommendedTwoWeeks',
    [PROMOTION_DURATION.MONTHLY]: 'highlightedRecommendedMonthly',
  },
};
